<template src="./html/Create.html"></template>

<script>
	import swal from 'sweetalert2'
	import Ladda from 'ladda'

	import MediaCreate from './../../../../../MediaManager/views/Create'

	export default {
		props: ['user', 'isAuth', 'data'],
		components: {
			'media-create': MediaCreate
		},
		data () {
			return {
				modal: {
					selector: 'modal-create-incident',
				},
				item: {
					title: null,
					description: null,
					task_id: this.data.id,
				},

				dropzone: {
					accepted: this.$env.ACCEPTED_DROPZONE_DOCS,
					url: this.$env.ROOT + '/api/' + this.$lang.getLang(),
				},

				incident: null,
			}
		},
		mounted() {
			var that = this
			$('#' + this.modal.selector).on('hidden.bs.modal', function () {
				that.clearData()
				that.$validator.reset()
			})
		},
		methods: {
			open() {
				this.incident = null
				var modal = $('#'+this.modal.selector)
				modal.modal('show')
			},
			close() {
				var modal = $('#'+this.modal.selector)
				modal.modal('hide')
			},
			clearData() {
				this.item.title = null
				this.item.description = null
				this.item.task_id = this.data.id
			},
			validate() {
				var that = this
				return this.$validator.validateAll().then((result) => {
					if(result) {
						that.store()
					}
					return result
				})
			},
			store() {
				var loading = Ladda.create(this.$refs.btnStore)
				loading.start()
				this.$http.post('admin/incident/reports', this.item)
				.then(response => {
					this.incident = response.body.data
					this.dropzone.url = this.$env.ROOT + '/api/' + this.$lang.getLang() + '/admin/incident/reports/' + this.incident.id
					this.$refs.mediaCreate.open()
					this.close()
					loading.stop()
					this.$emit('reload')
					swal({
						title: response.body.title,
						text: response.body.text,
						type: response.body.type,
					})
				}).catch(function(response) {
					loading.stop()
					console.log(response)
					swal({
						title: response.statusText,
						text: response.body,
						type: "warning",
					})
				})
			},
			reload(file) {
				this.$emit('reload')
			},
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/projects/tasks/components/incidentReports/views/Create.vue